/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';

import { Button, Typography } from '@atoms';
import { PageOrUrlField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { IMAGE_SIZE } from '@api/media/constants';

import Form from '../Form';

import { FORM_FIELDS } from './constants';

const BannerForm = React.forwardRef(
  ({ cropSize = IMAGE_SIZE['2000x240'], onFinish, hideButton, initialValues: data, isUltimateDesign }, ref) => {
    const [form] = Form.useForm(FORM_FIELDS);
    const initialValues = React.useMemo(() => form.deserialize(data), [data, form]);
    const pageRef = React.useRef();

    const handleSubmit = React.useCallback(
      (values) => {
        onFinish(values);
        // eslint-disable-next-line no-unused-expressions
        pageRef.current?.reset();
        form.resetFields();
      },
      [form, onFinish],
    );

    React.useImperativeHandle(ref, () => form);

    return (
      <Form
        form={form}
        layout="vertical"
        wrapperCol={{ span: 24 }}
        onSerializedFinish={handleSubmit}
        initialValues={initialValues}
      >
        <Typography.Title level={3}>Upload a banner</Typography.Title>
        <Typography.Title level={4}>Website image</Typography.Title>
        <MediaField {...FORM_FIELDS.IMAGE} size={cropSize} />
        {isUltimateDesign && <Typography.Title level={4}>Mobile image</Typography.Title>}
        {isUltimateDesign && <MediaField {...FORM_FIELDS.IMAGE_MOBILE} size={IMAGE_SIZE['390x428']} />}
        <PageOrUrlField ref={pageRef} {...FORM_FIELDS.PAGE} />
        {!hideButton && (
          <Button type="customBlue" onClick={form.submit}>
            ADD BANNER
          </Button>
        )}
      </Form>
    );
  },
);

export default BannerForm;
